import { useEffect } from "react";
import { useLocation, Outlet, Navigate, useNavigate } from "react-router-dom";

export default function OpenProgram() {
  const { search } = useLocation();           // “?program=cmtest&param=1”
    const params = new URLSearchParams(search); // native browser API
  const program = params.get("program") ?? "";
  const param   = params.get("param")   ?? "";
    const handle =  window.open(`${ program }:${ param }`);
    useEffect(() => {
        setTimeout(() => {
            window.location = ("/")
        }, 1000);
        
    },[program, param]);

  return <Outlet />;
}